/**
 * En-tête de la coquille : navigation en ARBRE à gauche (fil d'Ariane, via le slot
 * `nav`) et rangée d'actions à droite (`actions` : icônes de navigation primaire,
 * cloche à venir, menu de compte). Le wordmark a été retiré — l'icône Maison du fil
 * d'Ariane EST le retour à l'accueil. Sticky, responsive (ne déborde pas à 375px :
 * le fil tronque, les icônes restent compactes).
 */
interface HeaderProps {
  /** Navigation de gauche (fil d'Ariane dérivé de la route). */
  nav?: React.ReactNode;
  /** Actions de fin d'en-tête (icônes de navigation, cloche à venir, menu de compte). */
  actions?: React.ReactNode;
}

export function Header({ nav, actions }: HeaderProps): React.JSX.Element {
  return (
    <header className="z-10 shrink-0 border-b border-border bg-surface/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-5xl items-center gap-2 px-4">
        {/* Fil d'Ariane — flexible et tronquable pour ne pas pousser les actions. */}
        {nav && <div className="min-w-0 flex-1">{nav}</div>}

        {/* Actions — compactes, ne rétrécissent jamais. */}
        <div className="ms-auto flex shrink-0 items-center gap-1">{actions}</div>
      </div>
    </header>
  );
}
